import { Wrapper, TextWrapper } from "../../../constants/common/StyledGlobalConstants";
import PropTypes from "prop-types";

const FormTitle = ({ title, subTitle }) => {
  return (
    <Wrapper>
      <TextWrapper
        alignContent="center"
        fontSize="2.5rem"
        fontFamily="neue-haas-grotesk-display"
        fontWeight="700"
        lineHeight="3rem"
        aria-label={`${title}`}
      >
        {title}
      </TextWrapper>
      {subTitle && (
        <TextWrapper fontSize="0.875rem" fontWeight="400" marginTop="1.5rem !important">
          {subTitle}
        </TextWrapper>
      )}
    </Wrapper>
  );
};

FormTitle.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string
};

export default FormTitle;